import { ReactElement } from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const NewButton = (): ReactElement => {
  const navigate = useNavigate();
  return (
    <Button
      type='primary'
      onClick={() => {
        void navigate('/advisors/new');
      }}
    >
      新規作成
    </Button>
  );
};

export default NewButton;
